var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("btn addInputButton " + _vm.size),on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.text)),_c('b-icon-plus',{staticClass:"plusIcon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }